import { render, staticRenderFns } from "./land-arch-more-info.vue?vue&type=template&id=5bce214a"
import script from "./land-arch-more-info.vue?vue&type=script&lang=js"
export * from "./land-arch-more-info.vue?vue&type=script&lang=js"
import style0 from "./land-arch-more-info.vue?vue&type=style&index=0&id=5bce214a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports